export default __webpack_public_path__ + "static/media/hub_login-button.687fd8b2.svg";